module.exports = __webpack_public_path__ + "static/media/Yian Garuga.90376e29.png";


//////////////////
// WEBPACK FOOTER
// ./src/eggs/images/Yian Garuga.png
// module id = 147
// module chunks = 0